// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e_GCu36XMpIq_MMERMtG{flex-direction:column;gap:16px;display:flex}.SB1yUJJQwMwjzDFDs72b{border:1px solid var(--border-neutral-default);border-radius:16px;width:500px;padding:24px}.tYXcIbhbnaQbeY4EnUgh{flex-direction:column;gap:24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `e_GCu36XMpIq_MMERMtG`,
	"section": `SB1yUJJQwMwjzDFDs72b`,
	"editableSection": `tYXcIbhbnaQbeY4EnUgh`
};
export default ___CSS_LOADER_EXPORT___;
